// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require tinymce


import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import ReactOnRails from 'react-on-rails';
import './reactTurboCleanup';
import 'bundles/checkin/checkin';
import 'bundles/boxOffice/boxOffice';
import 'bundles/phoneInput/phoneInput';
import 'bundles/auth/passwordToggle';
import 'bundles/admin/eventNav';
import 'bundles/admin/eventForm';

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:before-cache", () => {
  // This tells React on Rails to prepare for a page swap
  // It helps prevent "double mounting" or components vanishing on 'Back' button
  ReactOnRails.reactOnRailsPageLoaded(); 
  // Que el snapshot cacheado nunca guarde el scroll bloqueado por el drawer
  document.documentElement.classList.remove('--drawer-open');
  // Ni modales de Bootstrap abiertos
  document.querySelectorAll('.modal.show').forEach((modal) => {
    modal.classList.remove('show');
    modal.style.display = 'none';
  });
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
});

document.addEventListener("turbo:load", () => {
  // This forces React on Rails to scan the DOM for any <%= react_component %> 
  // tags and mount them immediately.
  ReactOnRails.reactOnRailsPageLoaded();
});

// Add bootstrap
import "bootstrap";

// Chartkick con Chart.js empaquetado (sin cargador externo de Google Charts)
import "chartkick/chart.js"